import React from "react"

import { useAppDispatch } from "redux/hooks"
import { makeSignConsent } from "redux/features/consent/consentSignThunk"
import SmartId from "components/Sign/SmartId"
import { SMART_ID_SIGN_METHOD } from "config"
import { ClientSmartIdFormValues } from "types"

type Props = {
  onFailure: () => void
  onSuccess: () => void
}

const SmartIdSignComponent = ({ onFailure, onSuccess }: Props) => {
  const dispatch = useAppDispatch()

  const handleSubmit = (values: ClientSmartIdFormValues) => {
    const { country, personal_code } = values

    const params = {
      signing_method: SMART_ID_SIGN_METHOD,
      country_code: country,
      personal_code,
    }

    dispatch(makeSignConsent(params))
      .then(() => {
        onSuccess()
      })
      .catch(() => {
        onFailure()
      })
  }

  return <SmartId onSubmit={handleSubmit} />
}

export default SmartIdSignComponent
